export default __webpack_public_path__ + "static/media/gkpd.ffe8832b.png";